import { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { parseStringifiedJsonObj } from "utils/object";
import { transferConvToMe as transferConvToMeAction } from "redux/chats/chats.actions";
import ConfirmModal from "components/Modals/ConfirmModal";
import useTranslation from "hooks/useTranslation";
import { useNavigate } from "react-router-dom";

const CONFIRM_POPUP_ID = "TRANSFER_TO_ME_CONFIRM";

const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

// wrapps around button and listens to click button and transfers conversation
function TransferToMeWrapper({ children }) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const dispatch = useDispatch();
  const selectedConversation = useSelector(getSelectedConversation);
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();
  const navigate = useNavigate();

  const CONFIRM_TEXT = t("SURE_WANT_TO_TRANSFER_TO_YOURSELF");

  const transferConvToMe = () => {
    const clientId = selectedConversation.user?.id;
    const conversationId = selectedConversation.conversation.id;
    dispatch(transferConvToMeAction({ conversationId, clientId, navigate }));
  };

  // to transfer other operator's conversations to the current operator (other convs feature)
  const handleTransferConvToMeClick = () => {
    const shouldShowConfirmDialogue = getShouldShowConfirmDialogueStatus();

    if (shouldShowConfirmDialogue) {
      setShowConfirmModal(true);
      return;
    }

    transferConvToMe();
  };

  const getShouldShowConfirmDialogueStatus = () => {
    const strObj = localStorage.getItem(CONFIRM_POPUP_ID);
    const obj = parseStringifiedJsonObj(strObj);
    const status = obj?.status;
    const showDialogue = status !== "never";

    return showDialogue;
  };

  const handleShowModal = (status) => {
    setShowConfirmModal(false);
  };

  return (
    <div>
      <div onClick={handleTransferConvToMeClick}>{children}</div>
      <ConfirmModal
        text={CONFIRM_TEXT}
        showModal={showConfirmModal}
        setShowModal={handleShowModal}
        handleConfirm={transferConvToMe}
        popupId={CONFIRM_POPUP_ID}
        showAgainOption
      />
    </div>
  );
}

export default TransferToMeWrapper;
